import React, {useCallback} from 'react';
import {DragableLayout, Icon, Layout, Text} from '@di-nxt/components';
import {TaskProps} from './types';
import {useLocationColoring} from './useLocationColoring';
import {TaskWithEditInfo, useScheduleDataContext} from '../../services';
import dayjs from 'dayjs';

export const TaskElement: React.FC<TaskProps> = ({
  task,
  durationAmount,
  kind,
}) => {
  const context = useScheduleDataContext();
  const {color: locationColor, opacity: locationOpacity} = useLocationColoring(
    task.hubId,
  );
  const handleBeginDrag = useCallback(() => {
    console.log(
      'Task.beginDrag:',
      task.id,
      (task as TaskWithEditInfo).editMode,
    );

    context.beginDragTask(task.id);
  }, [context, task]);

  const handleEndDrag = useCallback(
    (_, didDrop: boolean) => {
      if (!didDrop) {
        console.log(
          'Task.cancelDrag:',
          task.id,
          (task as TaskWithEditInfo).editMode,
        );
        context.cancelDragTask(task.id);
      }
    },
    [context, task],
  );

  const editMode = (task as TaskWithEditInfo).editMode;
  const editing = editMode !== undefined && editMode !== 'dropped';

  // Make sure we only create drop targets for shifts that is within
  // the selected date when date kind is day
  const taskOnToday =
    kind === 'day' && dayjs(context.date).isSame(dayjs(task.distrDate), 'day');

  return kind === 'week' ? (
    // Week
    <Layout
      backgroundColor={locationColor}
      flex={durationAmount}
      borderRadius={'8'}
      opacity={locationOpacity}
      minWidth={2}
    />
  ) : (
    // Day
    <DragableLayout
      type={'Task'}
      enabled={taskOnToday}
      item={task}
      onBeginDrag={handleBeginDrag}
      onEndDrag={handleEndDrag}
      backgroundColor={locationColor}
      flex={durationAmount}
      overflow={'hidden'}
      borderRadius={'8'}
      opacity={locationOpacity ?? (editing ? 0.5 : undefined)}>
      <Layout
        absolute
        borderRadius={'8'}
        overflow="hidden"
        align="center"
        paddingLeft={'8'}>
        <Icon name="package" inverse filled size="16" />
        <Layout width={7} />
        <Text
          variant="inline_12_emphasis"
          nowrap
          textColor="content_mono_inverse_primary">
          {task.name}
        </Text>
      </Layout>
    </DragableLayout>
  );
};
